<template>
  <div id="app" class="container">
    <hero-image />
    <Home msg="Generated Startup Idea..."/>
  </div>
</template>

<script>
import HeroImage from './components/HeroImage'
import Home from './components/Home'

export default {
  name: 'app',
  components: {
    HeroImage,
    Home
  }
}
</script>

<style>
  body > .container {
    max-width: 720px;
  }
</style>
